import { FilterMatchMode } from "primereact/api";

export class Vehiculo {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            tipo_vehiculo: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de Vehículo:',
                required: 'Tipo de Vehículo es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            otro_vehiculo: {
                value: '',
                export: false,
                table: false,
                header: 'Otro tipo de vehículo:',
                required: 'Otro tipo de vehículo es requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },        
            numero_placa: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: true,
                filterField: 'numero_placa',
                header: 'NÚMERO DE PLACA O CHASIS:',
                required: 'Campo requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            modelo: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: true,
                filterField: 'modelo',
                header: 'MODELO Y AÑO DE FABRICACIÓN:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            marca: {
                value: '',
                export: false,
                table: true,
                sort: false,
                filter: true,
                filterField: 'marca',
                header: 'MARCA:',
                required: 'Campo requerido',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            valor_bien: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'VALOR DEL BIEN USD:',
                required: 'Valor del bien es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
